export default __webpack_public_path__ + "static/media/a009-ransomware-01.f44c0b7b.svg";